const auth = {
  loading: "Anwendung wird geladen...",
  loadError: "Anwendung konnte nicht geladen werden. Bitte versuchen Sie es später erneut.",
  logout: "Abmelden",
  connectionError: "Der Anmeldeserver ist nicht erreichbar. Bitte versuchen Sie es erneut.",
  retry: "Erneut versuchen",
  redirecting: "Weiterleitung zur Anmeldung...",
  noPermissionTitle: "Keine Berechtigung",
  noPermissionMessage:
    "Ihr Benutzerkonto hat keine Berechtigung für diese Anwendung. Melden Sie sich ab, um sich mit einem anderen Konto anzumelden.",
  signedInAs: "Angemeldet als",
};

export default auth;
